var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStartPlayingBig = function SvgStartPlayingBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#000",
    fillOpacity: 0.4,
    rx: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53.256 37.504c1.781 1.187 1.781 3.805 0 4.992L34.664 54.891C32.67 56.22 30 54.79 30 52.394V27.606c0-2.397 2.67-3.826 4.664-2.497z"
  })));
};
export default SvgStartPlayingBig;